import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface FreeListingsStatus {
  isEnabled: boolean;
  message: string;
  loading: boolean;
}

export const useFreeListingsStatus = () => {
  const [status, setStatus] = useState<FreeListingsStatus>({
    isEnabled: false,
    message: 'All listings are currently free',
    loading: true,
  });

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const { data, error } = await supabase
          .from('platform_settings')
          .select('setting_value')
          .eq('setting_key', 'free_listings_enabled')
          .single();

        if (error) throw error;

        const value = data.setting_value as { enabled: boolean; message: string };
        setStatus({
          isEnabled: value.enabled || false,
          message: value.message || 'All listings are currently free',
          loading: false,
        });
      } catch (error) {
        console.error('Error fetching free listings status:', error);
        setStatus(prev => ({ ...prev, loading: false }));
      }
    };

    fetchStatus();

    const channel = supabase
      .channel('platform_settings_changes')
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'platform_settings',
          filter: 'setting_key=eq.free_listings_enabled',
        },
        (payload) => {
          const newValue = payload.new.setting_value as { enabled: boolean; message: string };
          setStatus({
            isEnabled: newValue.enabled || false,
            message: newValue.message || 'All listings are currently free',
            loading: false,
          });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  return status;
};
